import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from '@heroicons/react/24/solid';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
 
const TrustedClients = () => {
  // Dynamically import all images from the Clients folder
  const importAll = (r) => r.keys().map(r);
  const clientImages = importAll(require.context('../Images/Clients', false, /\.(png|jpe?g|svg)$/));

  // Extract client names from image filenames (remove extension and format)
  const clientLogos = clientImages.map((image) => {
    const name = image
      .split('/')
      .pop()
      .replace(/\.(png|jpe?g|svg)$/i, '')
      .replace(/logo|Logo|LOGO/g, '')
      .replace(/[-_]/g, ' ')
      .trim();
    return { name, logo: image, industry: 'Global Fashion' };
  });
 
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
  };
   
  return (
    <section className="py-12 lg:py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center px-4 py-2 bg-honeycomb-blue-100 text-honeycomb-blue-800 rounded-full text-sm font-medium mb-6"
          >
            Trusted by Global Brands
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="text-3xl lg:text-4xl font-display font-bold text-honeycomb-grey-900 mb-4"
          >
            Trusted by Leading <span className="text-honeycomb-blue-600">Fashion</span> Brands Worldwide
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="text-lg text-honeycomb-grey-600 max-w-2xl mx-auto"
          >
            From emerging designers to global companies, leading brands choose us for quality, reliability, and global manufacturing excellence in knitted & woven garments.
          </motion.p>
        </motion.div>

        {/* Client Logos */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="mb-20"
        >
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center">
            {clientLogos.map((client) => (
              <motion.div
                key={client.name}
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -5 }}
                className="flex flex-col items-center group cursor-pointer"
              >
                <div className="w-32 h-32 rounded-xl flex items-center justify-center mb-3 transition-colors duration-300 overflow-hidden">
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="max-w-32 max-h-32 transition-all duration-300"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustedClients;
